/**
 * @flow
 */
export interface APIAction<T, R> {
  type: string;
  request?: T;
  response?: R;
  error?: Error;
}

export interface APIState<T, R> {
  status: '' | 'pending' | 'done' | 'error';
  request?: T;
  response?: R;
  error?: Error;
}

export interface User {
  id: number;
  email: string;
  userName: string; // 사용자 이름
  profileImg: string;
  displayName: string; // 사용자 타이틀
  permission: number;
}

export interface UserState extends User {
  token: string;
}

export interface UserAction {
  type: 'USER_UPDATE';
  user?: User;
  token?: string;
}

export interface RouteSegment {
  name: string;
  path?: string;
}

export interface BreadcrumbState {
  routeSegments?: RouteSegment[];
}

export interface BreadcrumbAction {
  type: 'BREADCRUMB_UPDATE';
  routeSegments?: RouteSegment[];
}

export interface Company {
  id: number; // id
  name: string; // cname
  active: 'Y' | 'N' | 'D'; // isactive
  partition: string; //partition
  createdAt: string; //cdate
}

export interface Branch {
  parentId: number; // cid
  id: number; // id
  name: string; // bname
  active: 'Y' | 'N' | 'D'; // isactive
  createdAt: string; //cdate
}

export interface Group {
  companyId: number; // cid
  parentId: number; // bid
  id: number; // id
  companyName: string; // cname
  branchName: string; // bname
  name: string; // gname
  active: 'Y' | 'N' | 'D'; // isactive
  createdAt: string; //cdate
}

export interface UserModel {
  companyId: number;
  branchId: number;
  groupId: number;
  id: number;
  name: string;
  active: 'Y' | 'N';
  cellno: string;
  email: string;
  pword: string;
  permission: 0 | 1 | 2;
  newPWD: string;
  profileImg: string;
}

export const PERM_SUPER_ADMIN = 0;
export const PERM_COMPANY_ADMIN = 10;
export const PERM_BRANCH_ADMIN = 11;
export const PERM_GROUP_ADMIN = 12;
export const PERM_USER = 20;

export interface Device {
  id: number;
  serial: string;
  name: string;
  active: 'Y' | 'N';
  groupId: number;
  typeId: number;
  gpsInfo: string;
}

export interface SDK {
  id?: number;
  protocol?: string;
  language?: string;
  datatype?: string;
}

export interface DeviceTypeModel {
  id: number;
  name: string;
  active: 'Y' | 'N';
  gline: any;
  maker: string;
  controller: 'Y' | 'N';
  topic: string;
  partition: string;
}

export interface ConnectModel {
  id: number;
  name: string;
  active: 'Y' | 'N';
  gline: any;
  controller: 'Y' | 'N';
  cmd_list: any;
  jextra: any;
}

export interface Patient {
  id: number,
  name: string,
  age: string,
  weight: string,
  height: string,
  testdate: string,
  testtrialtime: string,
  markers: any,
  eofirm: any,
  ecfirm: any,
  eofoam: any,
  ecfoam: any
  
}

export interface SettingsActionModel {
  id: number;
  pid: number;
  linkedId: number;
  active: 'Y' | 'N';
  withTimer: 'Y' | 'N';
  info: string;
  notify: string;
  cmdState: {
    type: string;
    data: number;
    up: boolean;
    act: 'ON' | 'OFF';
    offset: number;
  }[];
}

export interface SettingsTimerModel {
  id: number;
  pid: number;
  active: 'Y' | 'N';
  info: string;
  startTime: number;
  endTime: number;
}

export interface SettingsGuidelineModel {
  id: number;
  pid: number;
  gline: string;
}

export interface LogsNotificationModel {
  id: number;
  ntype: 'noti' | 'sensor' | 'warning',
  message: string;
  isdraft: 'Y' | 'N';
  company_id: number;
  cdate: number;
}
